module.exports = __webpack_public_path__ + "media/images/crosswords/p2-49e2cc9fdc6226a5a1a8af35f24de8c3.png";